import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { NotificationFileEntity } from './notification-file.entity';
import { NotificationGroupMemberEntity } from './notification-group-member.entity';
import { NotificationGroupEntity } from './notification-group.entity';
import { NotificationNotificationGroupStateEntity } from './notification-notification-group-state.entity';

@Index(
	'_created_date_fk__notification_group__id_to',
	['createdDate', 'fkNotificationGroupIdTo'],
	{},
)
@Index('_fk__notification_group__id_to', ['fkNotificationGroupIdTo'], {})
@Index(
	'_fk__notification_group_member__id_from',
	['fkNotificationGroupMemberIdFrom'],
	{},
)
@Entity('_notification')
export class NotificationEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__notification_group_member__id_from',
		nullable: true,
		unsigned: true,
	})
	public fkNotificationGroupMemberIdFrom!: number | null;

	@Column('int', { name: '_fk__notification_group__id_to', unsigned: true })
	public fkNotificationGroupIdTo!: number;

	@Column('longtext', { name: '_message', nullable: true })
	public message!: string | null;

	@Column('text', { name: '_error', nullable: true })
	public error!: string | null;

	@Column('varchar', { name: '_errorCode', nullable: true, length: 20 })
	public errorCode!: string | null;

	@ManyToOne(
		() => NotificationGroupMemberEntity,
		(notificationGroupMember) => notificationGroupMember.notifications,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{
			name: '_fk__notification_group_member__id_from',
			referencedColumnName: 'id',
		},
	])
	public fkNotificationGroupMemberIdFrom2!: NotificationGroupMemberEntity;

	@ManyToOne(
		() => NotificationGroupEntity,
		(notificationGroup) => notificationGroup.notifications,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk__notification_group__id_to', referencedColumnName: 'id' },
	])
	public fkNotificationGroupIdTo2!: NotificationGroupEntity;

	@OneToMany(
		() => NotificationFileEntity,
		(notificationFile) => notificationFile.fkNotification,
		{},
	)
	public notificationFiles!: Array<NotificationFileEntity>;

	@OneToMany(
		() => NotificationNotificationGroupStateEntity,
		(notificationNotificationGroupState) =>
			notificationNotificationGroupState.fkNotification,
		{},
	)
	public notificationNotificationGroupStates!: Array<NotificationNotificationGroupStateEntity>;

	@OneToMany(
		() => NotificationGroupEntity,
		(notificationGroup) => notificationGroup.fkNotificationIdLatest2,
		{},
	)
	public notificationGroups!: Array<NotificationGroupEntity>;
}
